import { Range } from '@weareopenr/types';

export const getRangeSubtitle = (ranges: Range[]): string =>
  ranges.length === 0 ? 'No Ranges' : ranges.map((range) => range.name).join(', ');
